import React from "react";
import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const scrollToFeatures = () => {
    const element = document.getElementById("features");
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-900"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900 via-emerald-900 to-slate-900"></div>

        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-teal-500/20 blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-emerald-500/10 blur-[120px]"></div>

        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      </div>

      <div className="relative z-10 w-full px-6 sm:px-10 lg:px-16">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge Kecil di atas Title */}
          {/* <div className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-wider text-teal-300 uppercase bg-teal-400/10 border border-teal-400/20 rounded-full backdrop-blur-md">
            Smart Housing Solution
          </div> */}

          <h1 className="text-4xl sm:text-6xl md:text-7xl font-extrabold text-white leading-[1.1] mb-6 tracking-tight">
            Satu Aplikasi Untuk <br className="hidden sm:block" />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-300 to-emerald-300">
              Seluruh Kebutuhan
            </span>{" "}
            Perumahan
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-slate-300/90 mb-10 max-w-2xl mx-auto leading-relaxed">
            Permudah pengelolaan pembayaran, keamanan, dan administrasi warga
            dalam satu ekosistem digital yang cerdas dan efisien.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate("/register")}
              className="w-full sm:w-auto bg-gradient-to-r from-teal-500 to-emerald-600 text-white px-10 py-4 rounded-xl text-lg font-bold hover:shadow-[0_0_20px_rgba(20,184,166,0.4)] transition-all duration-300 transform hover:-translate-y-1"
            >
              Daftar Sekarang
            </button>

            <button
              onClick={scrollToFeatures}
              className="w-full sm:w-auto bg-white/5 backdrop-blur-md text-white border border-white/20 px-10 py-4 rounded-xl text-lg font-semibold hover:bg-white/10 transition-all duration-300"
            >
              Pelajari Fitur
            </button>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToFeatures}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/50 cursor-pointer hover:text-white/70 transition-colors"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
